import { render, staticRenderFns } from "./PreventiveRecurringSchedule.vue?vue&type=template&id=022c1f87"
import script from "./PreventiveRecurringSchedule.vue?vue&type=script&lang=js"
export * from "./PreventiveRecurringSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports